module.exports = __webpack_public_path__ + "img/streams-text.af03f6e1.svg";